import { useEffect, useState } from 'react';
import clsx from 'clsx';
import edept from "@/assets/edept.png";

const navItems = [
  { label: 'Program', href: '#program' },
  { label: 'Why This Program', href: '#usps' },
  { label: 'Outcomes', href: '#outcomes' },
  { label: 'Curriculum', href: '#curriculum' },
  { label: 'FAQs', href: '#faqs' },
];

export default function Header({ onApplyClick }: { onApplyClick: () => void }) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={clsx(
        'fixed inset-x-0 top-0 z-50 transition-all duration-300 bg-white/95',
        scrolled ? 'shadow-card backdrop-blur' : '',
      )}
    >
      <div className="container-content flex items-center justify-between px-6 py-3 lg:px-16">
        <a href="#top" className="flex items-center gap-2" aria-label="edept home">
         <img src={edept} alt="edept logo" className="h-12"></img>
          {/* <span
            className={clsx(
              'hidden font-body text-xs uppercase tracking-[0.2em] sm:inline transition-colors',
              scrolled ? 'text-slate-500' : 'text-white/80',
            )}
          >
            M.S. Data Science
          </span> */}
        </a>

        <nav className="hidden items-center gap-8 lg:flex" aria-label="Primary">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={clsx(
                'text-lg font-medium transition-colors hover:text-edept-orange text-slate-700',
              )}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <button
          type="button"
          onClick={onApplyClick}
          className="rounded-full bg-edept-orange px-4 py-2 text-base font-semibold text-white shadow-card transition-transform hover:scale-[1.03] focus:outline-none focus-visible:ring-2 focus-visible:ring-edept-orange focus-visible:ring-offset-2"
        >
          Apply Now
        </button>
      </div>
    </header>
  );
}
